/* eslint-disable multiline-ternary */
import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Toast, Modal, ActivityIndicator } from 'zarm';
import { Upload } from '@iyunbao/components';
import _get from 'lodash.get';
import UItem from '../item';
import config from '../../config';
import fetchAPI from '../../utils/fetchAPI';
import { getFormId } from '../../utils/tools';
import { IUploadProps, IUploadState, ITokenProps, IFileProps } from './type';
import UploadModal from './modal';

const getValue = (props: IUploadProps) => {
  const { defaultValue, value } = props;
  if (typeof defaultValue !== 'undefined') {
    return defaultValue;
  }

  return value || '';
};

class UploadCertificate extends React.PureComponent<IUploadProps, IUploadState> {
  static propTypes = {
    prefixCls: PropTypes.string,
    onChange: PropTypes.func,
    quality: PropTypes.number,
    accept: PropTypes.string,
    uploadBtnImg: PropTypes.string,
    closeBtnImg: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'crm-upload-cert',
    onChange: () => { },
    quality: 0.8,
    accept: 'image/*',
    uploadBtnImg: 'https://static.iyb.tm/web/cr_mobile/icon_add.png',
    closeBtnImg: 'https://static.iyb.tm/web/cr_mobile/icon_close.png',
  };

  state: IUploadState = {
    fileUrl: getValue(this.props),
    visible: false,
    error: '',
    isLongImg: false, // 长图和宽图样式不一样
  };

  gupValue: string;

  // 是否需要重新验证
  needVid = {
    hasDefaultValue: false,
    needVid: false,
    defaultNum: '',
  };

  // static getDerivedStateFromProps(nextProps: IUploadProps, state: IUploadState) {
  //   if ('defaultValue' in nextProps && !deepAsset(nextProps.defaultValue, state.prevFiles)) {
  //     const isLongImg = getDefaultImage(nextProps);
  //     console.log(44444, isLongImg, nextProps);
  //     return {
  //       fileUrl: getValue(nextProps),
  //       prevFiles: nextProps.defaultValue,
  //       isLongImg,
  //     };
  //   }

  //   return null;
  // }

  componentDidMount() {
    try {
      const {
        refreshOptionsPath,
        _crengine = {},
      } = this.props;

      if (refreshOptionsPath) {
        const values = _crengine.form.getFieldsValue();
        const gupValue = _get(values, refreshOptionsPath);
        this.gupValue = gupValue;

        if (gupValue) {
          this.needVid.hasDefaultValue = true;
          this.needVid.defaultNum = gupValue;
        }
      }

      this.getDefaultImage(this.props);
    } catch (error) {
      console.warn(error);
    }
  }

  componentDidUpdate() {
    const {
      refreshOptionsPath,
      reloadMessage,
      _crengine = {},
    } = this.props;

    if (refreshOptionsPath && typeof refreshOptionsPath === 'string') {
      const values = _crengine.form.getFieldsValue();
      const { fileUrl } = this.state;
      const gupValue = _get(values, refreshOptionsPath);

      if (!gupValue) {
        this.needVid.needVid = true;
        return;
      }

      if (this.needVid.needVid && this.needVid.hasDefaultValue) {
        if (gupValue !== this.needVid.defaultNum) {
          if (this.gupValue !== gupValue) {
            this.gupValue = gupValue;
            this.onChange('');
            this.state.error = reloadMessage || '银行卡号变更，请重新上传';
          }
        } else {
          this.onChange({ fileUrl });
          this.state.error = '';
        }
        this.needVid.needVid = false;
      }
    }
  }

  onRemove() {
    const modal = Modal.confirm({
      title: '',
      content: '确认删除证件',
      onCancel: () => { },
      onOk: () => {
        modal.hide();
        this.setState({ fileUrl: '' });

        this.onChange({ fileUrl: '' });

        const { _crengine } = this.props;
        const { path, dataBind, form } = _crengine || {};

        // 重置 form value
        if (form && dataBind) {
          form.setFieldsValue({
            [getFormId(dataBind, path)]: '',
          });
        }
      },
    });
  }

  onChange(value) {
    const { onChange, ...rest } = this.props;

    const { _crengine } = this.props;
    const { path, dataBind, form } = _crengine || {};

    rest.value = value;

    // 重置 form value
    if (form && dataBind) {
      form.setFieldsValue({
        [getFormId(dataBind, path)]: value,
      });
    }

    onChange && onChange(value);
  }

  // 获取初始时候是长图还是短图
  getDefaultImage = (props: IUploadProps) => {
    const { defaultValue } = props;
    if (typeof defaultValue !== 'undefined' && /^(https?:\/\/)/.test(defaultValue)) {
      const img = new Image();
      img.src = defaultValue;
      img.onload = () => {
        const imgWidth = img.width;
        const imgHeight = img.height;

        this.setState({
          isLongImg: imgHeight >= imgWidth,
        });
      };
    }
  };

  // 选择文件
  onSelectFile = (file: IFileProps) => {
    const { readonly } = this.props;

    if (!file || readonly) {
      return null;
    }

    this.uploadFile(file).then((res) => {
      try {
        const fileUrl = typeof res === 'string' ? res : res.value;
        if (!(/^(https?:\/\/)/.test(res))) {
          return Toast.show(`图片地址不正确，请重新上传-${res}`);
        }
        // 图片适配 判别图片是长图还是宽度 长图高度100% 宽度居中。 宽图宽度100%高度自适应
        const img = new Image();
        img.src = fileUrl;
        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;

          this.setState({
            isLongImg: imgHeight >= imgWidth,
            error: '',
          });
        };

        this.setState({
          fileUrl,
        });

        this.onChange(fileUrl);
      } catch (error) {
        console.error('onSelectFile==', error);
      }
    });
  };

  // 获取token
  getToken: () => Promise<ITokenProps> = () => {
    const { tokenProps } = this.props;

    return new Promise((resolve) => {
      const fetchConfig = {
        url: `${config.iybtm.host}/sale/fstore/getToken.json`,
        method: 'post',
        data: {
          ...tokenProps,
        },
      };

      fetchAPI
        .fetchResult(fetchConfig, false)
        .then((content: any) => {
          resolve(content.result);
        })
        .catch((message: string) => {
          message && Toast.show(message);
        });
    });
  };

  // 获取ocr的token
  getOCRToken: () => Promise<any> = () => {
    const fetchConfig = {
      url: `${config.iybtm.host}/util/token.json`,
      method: 'post',
    };

    return fetchAPI
      .fetchResult(fetchConfig)
      .then((content: any) => {
        return content.result;
      })
      .catch((message: string) => {
        return Promise.reject(message);
      });
  };

  getMapkey = (key) => {
    switch (key) {
      case 'effectiveDate':
        return '有效起期';
      case 'expireDate':
        return '有效止期';
      case 'name':
        return '姓名';
      case 'certNo':
        return '证件号';

      default:
        break;
    }
  };

  /**
   * 上传文件
   * @param file 文件
   * @returns
   * 优化，接口参数格式（现在被限定，无法动态传OCR）
   * TODO OCR 地址后期修改
   */
  uploadFile = async (file: IFileProps) => {
    const { fetch: fetchData, ocr } = this.props;
    const uploadUrl: string = ocr ? `${config.gwiyb.host}/thirdparty/v2/ocr.json` : `${config.api.host}/facilities/open/v1/oss/file/upload/temp/uploadFile/base64`;
    const suffix: string = file.fileName ? file.fileName.split('.').pop() : '.jpg';

    // console.log('this.props==', this.props);

    if (ocr) {
      const { validate, ocrResKey = 'certNo' } = ocr;
      const { data, ...others } = fetchData || {};
      let fetchConfig = {
        url: uploadUrl,
        method: 'post',
        isLoading: true,
        data: {
          ...ocr.data,
          // 接口需要去除前面 data:image/jpg;base64,
          imageBase64: file.thumbnail,
          checkToken: '',
        },
      };

      fetchConfig = { ...fetchConfig, ...others };

      if (data && typeof data === 'object') {
        fetchConfig.data = { ...fetchConfig.data, ...data };
      }

      return this.getOCRToken().then((token) => {
        fetchConfig.data.checkToken = token;
        this.setState({ loading: true });

        return fetchAPI
          .fetchResult(fetchConfig)
          .then((content: any) => {
            this.setState({ loading: false });
            let error = '';

            // 银行卡需要校验
            if (this.needVid.hasDefaultValue) {
              if (_get(content.result, ocrResKey) === this.needVid.hasDefaultValue) {
                this.state.error = '';
                return content.result.url;
              }
              return Promise.reject(validate.message || '验证未通过，请重新上传');
            }

            if (validate && typeof validate === 'object') {
              Object.keys(validate).forEach((key) => {
                if (validate[key] !== content.result[key]) {
                  error = `订单信息的${this.getMapkey(key)}为：${validate[key]},影像信息为${content.result[key]}信息不一致`;
                }
              });

              if (error) {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject(error);
              }
              this.setState({
                error: '',
              });
              return content.result.url;
              // eslint-disable-next-line prefer-promise-reject-errors
              // return Promise.reject('验证未通过，请重新上传');
            }
            return content.result.url;
          })
          .catch((message: string) => {
            this.setState({ loading: false });

            message && Toast.show(message);
            this.setState({
              fileUrl: file.thumbnail,
              error: message,
            });
            this.onChange('');
            return Promise.reject(message);
          });
      });
    }

    const { clientId, token } = await this.getToken();

    if (!(clientId && token)) {
      return Toast.show('图片上传获取token失败');
    }
    this.setState({ loading: true });

    const fetchConfig = {
      url: `${config.fs.host}/open/v1/upload/base64`,
      method: 'post',
      isLoading: true,
      headers: {
        Authorization: token,
        ClientId: clientId,
      },
      data: {
        base64: file.thumbnail,
        suffix,
      },
    };

    return fetchAPI
      .fetchResult(fetchConfig)
      .then((content: any) => {
        this.setState({ loading: false });
        if (!(/^(https?:\/\/)/.test(content.result))) {
          return Toast.show(`图片地址不正确，请重新上传-${content.result}`);
        }
        return Promise.resolve(content.result);
      })
      .catch((message: string) => {
        message && Toast.show(message);
        this.setState({ loading: false });
      });
  };

  // 预览
  preview = () => {
    this.setState({
      visible: true,
    });
  };

  // 弹窗回调方法
  uploadModelChange = (item) => {
    const { type, data } = item;

    switch (type) {
      case 'fileUpload':
        this.setState({
          visible: false,
          fileUrl: '',
        });
        this.onSelectFile(data);
        break;
      case 'close':
        this.setState({
          visible: false,
        });
        break;

      default:
        break;
    }
  };

  renderContent() {
    const { fileUrl, error, loading, isLongImg } = this.state;

    const {
      prefixCls,
      accept = 'image/*',
      quality = 0.8,
      className,
      validate,
      readonly,
      _crengine,
      bgImg = '',
      title = '',
      width = '44vw',
      height = '26.4vw',
      uploadBtnImg,
      closeBtnImg,
      style,
      ...others
    } = this.props;
    const cls = classnames(prefixCls, className);
    const styleObj = {
      backgroundImage: `url(${bgImg})`,
      width,
      height,
      ...style,
    };
    const imgCls = classnames('img', { 'long-img': isLongImg, 'width-img': !isLongImg });

    return (
      <div className={cls} style={styleObj}>
        {fileUrl ? (
          <div className={`${prefixCls}-img-warp`}>
            {!readonly && (
              <div className={`${prefixCls}-img-warp-bg`}>
                <div className="delete-icon-wrap" onClick={() => this.onRemove()}>
                  <img className="delete-icon" src={closeBtnImg} alt="" />
                </div>
              </div>
            )}
            <img className={imgCls} onClick={() => this.preview()} src={fileUrl} alt="" />
            {error && (
              <div className="error-wrap" onClick={() => this.preview()}>
                <div className="error-wrap-tips">{error || '证件影像与投保人信息不符请重新上传'}</div>
              </div>
            )}
          </div>
        ) : (
          <>
            <Upload
              {...others}
              className={`${prefixCls}-file`}
              accept={accept}
              quality={quality}
              onChange={(file: IFileProps) => this.onSelectFile(file)}
            >
              {loading ? (
                <div className="loading-wrap">
                  <ActivityIndicator size="lg" />
                </div>
              ) : (
                <img className="icon-jiaxin" src={uploadBtnImg} alt="上传按钮" />
              )}
            </Upload>
            {title && <div className={`${cls}-title`}>{title}</div>}
          </>
        )}
      </div>
    );
  }

  render() {
    const { onChange, defaultValue, ...rest } = this.props;
    const { fileUrl, visible } = this.state;

    return (
      <>
        <UItem {...rest} initialValue={defaultValue || ''} samePath itemType="upload">
          {this.renderContent()}
        </UItem>
        <UploadModal visible={visible} fileUrl={fileUrl} accept={rest.accept} quality={rest.quality} onChange={(data) => this.uploadModelChange(data)} />
      </>
    );
  }
}

export default UploadCertificate;
